import React, { useRef } from 'react';
import FixedContainer from '@base/lib/FixedContainer';
import Iconfont from '@base/lib/Iconfont';
import { scrollToTop } from 'base/utils/scrollTo';
import styles from './index.module.less';

const SideWidgets: React.FC = () => {
    const ref = useRef<HTMLDivElement>(null);
    return (
        <FixedContainer
            className={styles['side-widgets']}
            width={40}
            placement={['right', 'bottom']}
            offset={[0, 100]}
        >
            <div className={styles.widget} onClick={scrollToTop}>
                <Iconfont className="icon-top"/>
            </div>
            <div ref={ref} className="relative"></div>
        </FixedContainer>
    );
}

export default SideWidgets;
